import React from 'react';
import GenericCadastroPage from './GenericCadastroPage';
import { validateEmail, validateCpfCnpj, validatePhone } from '@/utils/cadastroValidation';
import { useCadastrosOptions } from '@/hooks/useCadastrosOptions';

export default function PessoasPage() {
  const { options: tipoPessoaOptions } = useCadastrosOptions('tipo_pessoa_v2', 'id', 'descricao');

  const columns = [
    { key: 'nome', label: 'Nome' },
    { key: 'cpf_cnpj', label: 'CPF/CNPJ' },
    { key: 'email', label: 'E-mail' },
    { key: 'telefone', label: 'Telefone' },
  ];

  const fields = [
    { name: 'nome', label: 'Nome Completo', required: true },
    { name: 'cpf_cnpj', label: 'CPF / CNPJ', required: false, validate: validateCpfCnpj },
    { name: 'email', label: 'E-mail', required: false, validate: validateEmail },
    { name: 'telefone', label: 'Telefone', required: false, validate: validatePhone },
    { 
      name: 'tipo_pessoa_id', 
      label: 'Tipo de Pessoa', 
      type: 'select', 
      options: tipoPessoaOptions, 
      required: false 
    },
    { name: 'endereco', label: 'Endereço', type: 'textarea', required: false },
  ];

  return (
    <GenericCadastroPage
      title="Pessoas"
      description="Gerencie os registros de pessoas físicas e jurídicas."
      tableName="pessoas_v2"
      columns={columns}
      fields={fields}
    />
  );
}